export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const NUMBER_OF_PICKUP_DAYS = 5;

export const DATE_PICKER_START_OFFSET_IN_DAYS = 1;

export const ALL_DAY_TIME_WINDOW = '0900-1600';

export const MODAL_VERSION_1 = 'v1';
export const MODAL_VERSION_2 = 'v2';
export const MODAL_VERSION_3 = 'v3';
